var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2476_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1073 1.70581C12.0686 1.70581 12.0303 1.71344 11.9945 1.72825C11.9588 1.74307 11.9263 1.76478 11.8989 1.79216C11.8715 1.81954 11.8498 1.85203 11.835 1.8878C11.8202 1.92357 11.8125 1.96191 11.8125 2.00062V6.31694C11.8125 7.55894 12.4102 8.66125 13.3335 9.35219C14.5507 10.2631 15.286 11.6787 15.286 13.1991V14.8099H17.1139V13.1991C17.1139 11.6787 17.8492 10.2631 19.0665 9.35219C19.9898 8.66125 20.5874 7.55894 20.5874 6.31694V2.00069C20.5874 1.9225 20.5563 1.84751 20.5011 1.79222C20.4458 1.73693 20.3708 1.70587 20.2926 1.70587H12.1073V1.70581Z",
    fill: "#F9C662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 2.00075V6.317C20.5875 7.55887 19.99 8.66137 19.0662 9.352C17.8494 10.2632 17.1137 11.6789 17.1137 13.1989V14.8101H15.2862V13.1989C15.2862 12.7201 15.2131 12.2514 15.075 11.8057C15.375 10.837 15.9825 9.97637 16.8162 9.352C17.74 8.66137 18.3375 7.55887 18.3375 6.317V2.00075C18.3375 1.83762 18.2056 1.70575 18.0425 1.70575H20.2925C20.4556 1.70575 20.5875 1.83756 20.5875 2.00075Z",
    fill: "#FE9901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 3.68312V2.00068C20.5875 1.9225 20.5564 1.84751 20.5011 1.79222C20.4458 1.73693 20.3708 1.70587 20.2927 1.70587H12.1073C12.0686 1.70587 12.0303 1.7135 11.9945 1.72831C11.9588 1.74313 11.9263 1.76484 11.8989 1.79222C11.8715 1.8196 11.8498 1.8521 11.835 1.88786C11.8202 1.92363 11.8125 1.96197 11.8125 2.00068V3.68312H20.5875Z",
    fill: "#FFF0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2926 1.70581H18.0435C18.1216 1.70599 18.1964 1.73715 18.2515 1.79244C18.3066 1.84772 18.3376 1.92262 18.3375 2.00069V3.68312H20.5875V2.00069C20.5875 1.92248 20.5564 1.84748 20.5011 1.79218C20.4458 1.73688 20.3708 1.70581 20.2926 1.70581Z",
    fill: "#FFD15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 3.68312H20.5875M13.9833 1.70581H12.1073C12.0292 1.70581 11.9542 1.73687 11.8989 1.79216C11.8436 1.84745 11.8125 1.92243 11.8125 2.00062V6.31694C11.8125 7.55894 12.4102 8.66125 13.3335 9.35219C14.5507 10.2631 15.2861 11.6787 15.2861 13.1991V14.8099H17.114V13.1991C17.114 11.6787 17.8493 10.2631 19.0665 9.35219C19.9898 8.66125 20.5875 7.55894 20.5875 6.31694V2.00069C20.5875 1.9225 20.5564 1.84751 20.5011 1.79222C20.4458 1.73693 20.3708 1.70587 20.2927 1.70587H16.0246",
    stroke: "#0D1533",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7312 29.6692V21.3191C31.7312 20.9739 31.4514 20.6941 31.1062 20.6941H21.3738V15.7566C21.3738 15.4114 21.094 15.1316 20.7488 15.1316H11.6512C11.306 15.1316 11.0262 15.4114 11.0262 15.7566V20.6941H1.29373C0.948544 20.6941 0.668732 20.9739 0.668732 21.3191V29.6692C0.668732 30.0144 0.948544 30.2942 1.29373 30.2942H31.1062C31.4514 30.2942 31.7312 30.0144 31.7312 29.6692Z",
    fill: "#FFD15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7312 21.3192V29.6692C31.7312 30.0144 31.4514 30.2942 31.1062 30.2942H29.2312V21.3192C29.2312 20.9742 28.9512 20.6942 28.6062 20.6942H31.1062C31.4514 20.6942 31.7312 20.974 31.7312 21.3192ZM21.3737 15.7567V20.6942H18.8737V15.7567C18.8737 15.4117 18.5937 15.1317 18.2487 15.1317H20.7487C21.0937 15.1317 21.3737 15.4117 21.3737 15.7567Z",
    fill: "#F4B74A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7312 29.6692V23.1941H21.9988C21.6536 23.1941 21.3738 22.9143 21.3738 22.5691V17.6316H11.0262V22.5691C11.0262 22.9143 10.7464 23.1941 10.4012 23.1941H0.668732V29.6692C0.668732 30.0144 0.948544 30.2942 1.29373 30.2942H31.1062C31.4514 30.2942 31.7312 30.0144 31.7312 29.6692Z",
    fill: "#A0AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7312 23.1942V29.6692C31.7312 30.0144 31.4514 30.2942 31.1062 30.2942H29.2312V23.1942H31.7312Z",
    fill: "#8396FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7312 24.9319V21.3191C31.7312 20.9739 31.4514 20.6941 31.1062 20.6941H21.3738V15.7566C21.3738 15.4114 21.094 15.1316 20.7488 15.1316H11.6512C11.306 15.1316 11.0262 15.4114 11.0262 15.7566V20.6941H1.29373C0.948544 20.6941 0.668732 20.9739 0.668732 21.3191V29.6692C0.668732 30.0144 0.948544 30.2942 1.29373 30.2942H31.1062C31.4514 30.2942 31.7312 30.0144 31.7312 29.6692V26.9732",
    stroke: "#0D1533",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7312 23.1941H21.9988C21.6536 23.1941 21.3738 22.9143 21.3738 22.5691V17.6316H11.0262V22.5691C11.0262 22.9143 10.7464 23.1941 10.4012 23.1941H0.668732",
    stroke: "#0D1533",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 26.4312C17.9083 26.4312 19.2932 25.0463 19.2932 23.3379C19.2932 21.6296 17.9083 20.2447 16.2 20.2447C14.4916 20.2447 13.1067 21.6296 13.1067 23.3379C13.1067 25.0463 14.4916 26.4312 16.2 26.4312Z",
    fill: "#F4B74A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.293 23.3379C19.293 25.0466 17.9085 26.431 16.2 26.431C15.8915 26.4313 15.5848 26.3854 15.29 26.2948C16.5544 25.9069 17.4737 24.7298 17.4737 23.3379C17.4737 21.946 16.5544 20.7689 15.29 20.381C15.5848 20.2904 15.8915 20.2445 16.2 20.2448C17.9086 20.2448 19.293 21.6293 19.293 23.3379Z",
    fill: "#FE9901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 26.4312C17.9083 26.4312 19.2932 25.0463 19.2932 23.3379C19.2932 21.6296 17.9083 20.2447 16.2 20.2447C14.4916 20.2447 13.1067 21.6296 13.1067 23.3379C13.1067 25.0463 14.4916 26.4312 16.2 26.4312Z",
    stroke: "#0D1533",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8499 22.5632L16.3342 22.3369V24.2986",
    stroke: "#0D1533",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7023 15.1316H12.6977V13.9911C12.6977 13.6289 12.9913 13.3353 13.3535 13.3353H19.0465C19.4087 13.3353 19.7023 13.6289 19.7023 13.9911V15.1316H19.7023Z",
    fill: "#F4B74A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7025 13.9914V15.1314H17.5775V13.9914C17.5775 13.6289 17.2837 13.3351 16.9212 13.3351H19.0462C19.4087 13.3351 19.7025 13.6289 19.7025 13.9914Z",
    fill: "#FE9901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6482 2.49081H23.303C23.6482 2.49081 23.928 2.77063 23.928 3.11581V5.80225C23.928 6.991 22.9643 7.95469 21.7755 7.95469H20.2767M11.7517 2.49081H9.09698C8.7518 2.49081 8.47198 2.77063 8.47198 3.11581V5.80225C8.47198 6.991 9.43567 7.95469 10.6244 7.95469H12.1232M19.7023 15.1316H12.6977V13.9911C12.6977 13.6289 12.9913 13.3353 13.3535 13.3353H19.0465C19.4087 13.3353 19.7024 13.6289 19.7024 13.9911V15.1316H19.7023Z",
    stroke: "#0D1533",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2476_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.199982)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaders);
export default __webpack_public_path__ + "static/media/leaders.54b52fbb214da8c4cfb45e682c537dba.svg";
export { ForwardRef as ReactComponent };